import axios from 'axios';
import { getUserGroupQuery } from '.';

const getUserGroupsByIds = ({ ids, fields }) =>
    new Promise((resolve, reject) => {
        const userGroupQuery = getUserGroupQuery({ ids, fields });
        const userGroupRequest = axios.get(userGroupQuery);
        userGroupRequest
            .then((userGroupResponse) => {
                resolve(userGroupResponse.data);
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to process request'));
            });
    });

export default getUserGroupsByIds;
